class CFaqPage extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.faq-page__tab')
    this.items = this.querySelectorAll('.container-accordeon')
    this.bindEvents()
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.activateTab(index)
      })
    })
  }

  activateTab(index) {
    this.tabs.forEach((tab) => tab.classList.remove('is-active'))
    this.items.forEach((item) => item.classList.remove('is-active'))
    this.tabs[index].classList.add('is-active')
    this.items[index].classList.add('is-active')
  }
}

customElements.define('c-faq-page', CFaqPage)
